// @flow

export type Option = {
    id: number,
    text: string,
    disabled: boolean,
    code?: string,
    serverValue: number | string
};

export type OptionList = Option[];

export default class OptionManager {

    availableSelections: {
        techniquesToCompare: OptionList,
        typeOfLandscape: OptionList,
        coating: OptionList,
        streetType: OptionList,
        asphaltType: OptionList,
        tubeType: OptionList,
        tubeMaterialAll: OptionList,
        tubeDiameterAll: OptionList,
        slopeAngle: OptionList,

        coatingStreet: OptionList,
        coatingVirgin: OptionList,

        tubeTypeIfl: OptionList,
        tubeTypePul: OptionList,
        tubeTypeSl: OptionList,

        tubeMaterialDrain: OptionList,
        tubeMaterialWater: OptionList,

        tubeMaterialTradDrain: OptionList,
        
        tubeMaterialTcDrain: OptionList,
        tubeMaterialTcWater: OptionList,
        
        tubeMaterialDdDrain: OptionList,
        tubeMaterialDdWater: OptionList,
        
        tubeMaterialSl: OptionList,

        tubeDiameterDrainConcrete: OptionList,
        tubeDiameterTradDrainConcrete: OptionList,
        tubeDiameterDrainPvc: OptionList,
        tubeDiameterDrainPe: OptionList,
        tubeDiameterDrainPp: OptionList,
        tubeDiameterWaterPe: OptionList,
        tubeDiameterTradWaterPe: OptionList,
        tubeDiameterTcWaterPe: OptionList,
        tubeDiameterDdWaterPe: OptionList,
        tubeDiameterWaterGreyIron: OptionList,
        tubeDiameterTcWaterGreyIron: OptionList,
        tubeDiameterWaterSteel: OptionList,

        tubeDiameterIfl: OptionList,

        tubeDiameterTcDrainPe: OptionList,
        
        tubeDiameterDdDrainPe: OptionList,
        
        tubeDiameterSlPe: OptionList,
        tubeDiameterSlGreyIron: OptionList,

        tubeDiameterPul: OptionList,
    };

    ids: {
        [code: string]: number;
    } = {};

    constructor() {

        const tubeTypeAll = [
            {id: 1, text: "Avlopp", disabled: false, code: "TUBE_TYPE_DRAIN", serverValue: "avlopp"},
            {id: 2, text: "Dagvatten", disabled: false, code: "TUBE_TYPE_SURFACE_WATER", serverValue: "dagvatten"},
            {id: 3, text: "Vatten", disabled: false, code: "TUBE_TYPE_WATER", serverValue: "vatten"},
        ];

        const coatingAll = [
            {id: 1, text: "Asfalt", disabled: false, code: "COATING_ASPHALT", serverValue: "asfalt"},
            {id: 2, text: "Grus", disabled: false, code: "COATING_GRAVEL", serverValue: "grus"},
            {id: 3, text: "Grönyta", disabled: false, code: "COATING_GREEN", serverValue: "grönyta"},
        ];

        const tubeMaterialAll = [
            {id: 1, text: "Betong", disabled: false, code: "TUBE_MATERIAL_CONCRETE", serverValue: "betong"},
            {id: 2, text: "PVC", disabled: false, code: "TUBE_MATERIAL_PVC", serverValue: "PVC"},
            {id: 3, text: "PE", disabled: false, code: "TUBE_MATERIAL_PE", serverValue: "PE"},
            {id: 4, text: "Gråjärn/Segjärn", disabled: false, code: "TUBE_MATERIAL_GREY_IRON", serverValue: "gråjärn/segjärn"},
            {id: 5, text: "Stål", disabled: false, code: "TUBE_MATERIAL_STEEL", serverValue: "stål"},
            {id: 6, text: "PP", disabled: false, code: "TUBE_MATERIAL_PP", serverValue: "PP"},
        ];

        // Id order and serverValue order must be same
        const tubeDiameterAll = [
            {id: 10, text: "80", disabled: false, serverValue: 80},
            {id: 20, text: "100", disabled: false, serverValue: 100},
            {id: 30, text: "110", disabled: false, serverValue: 110},
            {id: 40, text: "125", disabled: false, serverValue: 125},
            {id: 50, text: "150", disabled: false, serverValue: 150},
            {id: 60, text: "160", disabled: false, serverValue: 160},
            {id: 70, text: "180", disabled: false, serverValue: 180},
            {id: 80, text: "200", disabled: false, serverValue: 200},
            {id: 90, text: "225", disabled: false, serverValue: 225},
            {id: 100, text: "250", disabled: false, serverValue: 250},
            {id: 110, text: "280", disabled: false, serverValue: 280},
            {id: 120, text: "300", disabled: false, serverValue: 300},
            {id: 130, text: "315", disabled: false, serverValue: 315},
            {id: 140, text: "350", disabled: false, serverValue: 350},
            {id: 150, text: "355", disabled: false, serverValue: 355},
            {id: 155, text: "375", disabled: false, serverValue: 375},
            {id: 160, text: "400", disabled: false, serverValue: 400},
            {id: 165, text: "450", disabled: false, serverValue: 450},
            {id: 170, text: "500", disabled: false, serverValue: 500},
            {id: 175, text: "560", disabled: false, serverValue: 560},
            {id: 180, text: "600", disabled: false, serverValue: 600},
            {id: 190, text: "630", disabled: false, serverValue: 630},
            {id: 193, text: "700", disabled: false, serverValue: 700},
            {id: 195, text: "710", disabled: false, serverValue: 710},
            {id: 200, text: "800", disabled: false, serverValue: 800},
            {id: 210, text: "1000", disabled: false, serverValue: 1000},
            {id: 220, text: "1200", disabled: false, serverValue: 1200},
            {id: 230, text: "1300", disabled: false, serverValue: 1300},
            {id: 240, text: "1400", disabled: false, serverValue: 1400},
            {id: 250, text: "1600", disabled: false, serverValue: 1600},
        ];

        this.availableSelections =  {
            techniquesToCompare: [
                {id: 1, text: "Flexibla foder", disabled: false, code: 'TECH_IFL', serverValue: "Traditionell grävning jämfört med Infodring med flexibla foder"},
                {id: 2, text: "Rörspräckning", disabled: false, code: 'TECH_TC', serverValue: "Traditionell grävning jämfört med Rörspräckning"},
                {id: 3, text: "Styrd borrning", disabled: false, code: 'TECH_DD', serverValue: "Traditionell grävning jämfört med Styrd borrning"},
                {id: 4, text: "Sliplining", disabled: false, code: 'TECH_SL', serverValue: "Traditionell grävning jämfört med Sliplining"},
                {id: 5, text: "PU liner", disabled: false, code: 'TECH_PUL', serverValue: "Traditionell grävning jämfört med PU liner"},
                {id: 6, text: "Flexibla foder samt Rörspräckning", disabled: false, code: 'TECH_IFL_TC', serverValue: "Traditionell grävning jämfört med Infodring med flexibla foder samt Rörspräckning"},
                {id: 7, text: "Flexibla foder samt Sliplining", disabled: false, code: 'TECH_IFL_SL', serverValue: "Traditionell grävning jämfört med Infodring med flexibla foder samt Sliplining"},
                {id: 8, text: "Flexibla foder samt Styrd borrning", disabled: false, code: 'TECH_IFL_DD', serverValue: "Traditionell grävning jämfört med Infodring med flexibla foder samt Styrd borrning"},
                {id: 9, text: "Flexibla foder samt PU liner", disabled: false, code: 'TECH_IFL_PUL', serverValue: "Traditionell grävning jämfört med Infodring med flexibla foder samt PU liner"},
                {id: 10, text: "Rörspräckning samt Styrd borrning", disabled: false, code: 'TECH_TC_DD', serverValue: "Traditionell grävning jämfört med Rörspräckning samt Styrd borrning"},
                {id: 11, text: "Rörspräckning samt Sliplining", disabled: false, code: 'TECH_TC_SL', serverValue: "Traditionell grävning jämfört med Rörspräckning samt Sliplining"},
                {id: 12, text: "Rörspräckning samt PU liner", disabled: false, code: 'TECH_TC_PUL', serverValue: "Traditionell grävning jämfört med Rörspräckning samt PU liner"},
                {id: 13, text: "Styrd borrning samt Sliplining", disabled: false, code: 'TECH_DD_SL', serverValue: "Traditionell grävning jämfört med Styrd borrning samt Sliplining"},
                {id: 14, text: "Styrd borrning samt PU liner", disabled: false, code: 'TECH_DD_PUL', serverValue: "Traditionell grävning jämfört med Styrd borrning samt PU liner"},
            ],
            typeOfLandscape: [
                {id: 1, text: "Gatumiljö", disabled: false, code: "TYPE_OF_LANDSCAPE_STREET", serverValue: "gatumiljö"},
                {id: 2, text: "Jungfrulig mark", disabled: false, code: "TYPE_OF_LANDSCAPE_VIRGIN", serverValue: "jungfrulig mark"},
            ],
            coating: coatingAll,
            streetType: [
                {id: 1, text: "Stadsgata", disabled: false, code: "STREET_TYPE_CITY", serverValue: "stadsgata"},
                {id: 2, text: "Villagata", disabled: false, code: "STREET_TYPE_RESIDENTIAL", serverValue: "villagata"},
            ],
            asphaltType: [
                {id: 1, text: "Grön", disabled: false, code: "ASPHALT_TYPE_GREEN", serverValue: "grön"},
                {id: 2, text: "Traditionell", disabled: false, code: "ASPHALT_TYPE_TRADITIONAL", serverValue: "traditionell"},
            ],
            tubeType: tubeTypeAll,
            slopeAngle: [
                {id: 1, text: "1", disabled: false, code: "SLOPE_ANGLE_1", serverValue: 1},
                {id: 2, text: "2", disabled: false, code: "SLOPE_ANGLE_2", serverValue: 2},
                {id: 3, text: "3", disabled: false, code: "SLOPE_ANGLE_3", serverValue: 3},
                {id: 4, text: "4", disabled: false, code: "SLOPE_ANGLE_4", serverValue: 4},
                {id: 5, text: "5", disabled: false, code: "SLOPE_ANGLE_5", serverValue: 5},
            ],

            coatingStreet: coatingAll.filter(
                item => ['COATING_ASPHALT', 'COATING_GRAVEL'].includes(item.code)),

            coatingVirgin: coatingAll.filter(
                item => ['COATING_GRAVEL', 'COATING_GREEN'].includes(item.code)),

            tubeTypeIfl: tubeTypeAll.filter(
                item => ['TUBE_TYPE_DRAIN', 'TUBE_TYPE_SURFACE_WATER'].includes(item.code)),

            tubeTypePul: tubeTypeAll.filter(
                item => ['TUBE_TYPE_WATER'].includes(item.code)),

            tubeTypeSl: tubeTypeAll.filter(
                item => ['TUBE_TYPE_WATER'].includes(item.code)),


            tubeMaterialAll: tubeMaterialAll,
            tubeMaterialDrain: tubeMaterialAll.filter(
                item => ['TUBE_MATERIAL_CONCRETE', 'TUBE_MATERIAL_PVC'].includes(item.code)),

            tubeMaterialWater: tubeMaterialAll.filter(
                item => ['TUBE_MATERIAL_PE', 'TUBE_MATERIAL_GREY_IRON', 'TUBE_MATERIAL_STEEL'].includes(item.code)),

            tubeMaterialTradDrain: tubeMaterialAll.filter(
                item => ['TUBE_MATERIAL_CONCRETE', 'TUBE_MATERIAL_PP'].includes(item.code)),

            tubeMaterialTcDrain: tubeMaterialAll.filter(
                item => ['TUBE_MATERIAL_PE'].includes(item.code)),

            tubeMaterialTcWater: tubeMaterialAll.filter(
                item => ['TUBE_MATERIAL_PE', 'TUBE_MATERIAL_GREY_IRON'].includes(item.code)),
            
            tubeMaterialDdDrain: tubeMaterialAll.filter(
                item => ['TUBE_MATERIAL_PE'].includes(item.code)),

            tubeMaterialDdWater: tubeMaterialAll.filter(
                item => ['TUBE_MATERIAL_PE', 'TUBE_MATERIAL_STEEL'].includes(item.code)),

            tubeMaterialSl: tubeMaterialAll.filter(
                item => ['TUBE_MATERIAL_PE', 'TUBE_MATERIAL_GREY_IRON'].includes(item.code)),
            
            

            tubeDiameterAll: tubeDiameterAll,
            tubeDiameterDrainConcrete: tubeDiameterAll.filter(
                item => ["150", "225", "300", "375", "400", "450", "500", "600", "800", "1000", "1200", "1600"].includes(item.text)),
            tubeDiameterTradDrainConcrete: tubeDiameterAll.filter(
                item => ["150", "225", "300",  "400", "500", "600", "800", "1000", "1200", "1600"].includes(item.text)),

            tubeDiameterDrainPvc: tubeDiameterAll.filter(
                item => ["110", "160", "200", "250", "315", "400", "500", "630", "800", "1000", "1200"].includes(item.text)),

            tubeDiameterTcDrainPe: tubeDiameterAll.filter(
                item => ["110", "160", "180", "200", "250", "280", "315", "355", "400", "450", "500", "560", "630", "710", "800", "1000"].includes(item.text)),

            tubeDiameterDdDrainPe: tubeDiameterAll.filter(
                item => ["110", "160", "180", "200", "250", "280", "315", "355", "400", "450", "500", "560", "630", "710", "800", "1000", "1200"].includes(item.text)),

            tubeDiameterDrainPp: tubeDiameterAll.filter(
                item => ["110", "160", "200", "250", "315", "400", "500", "630", "800", "1000", "1200"].includes(item.text)),

            tubeDiameterDrainPe: tubeDiameterAll.filter(
                item => ["1600"].includes(item.text)),

            tubeDiameterWaterPe: tubeDiameterAll.filter(
                item => ["110", "160", "180", "200", "250", "280", "315", "355", "400", "450", "500", "560", "630", "710"].includes(item.text)),
            tubeDiameterTradWaterPe: tubeDiameterAll.filter(
                item => ["110", "160", "180", "200", "250", "280", "315", "355", "400", "450", "500", "560", "630", "710", "800", "1000", "1200"].includes(item.text)),
            tubeDiameterTcWaterPe: tubeDiameterAll.filter(
                item => ["110", "160", "180", "200", "250", "280", "315", "355", "400", "450", "500", "560", "630", "710", "800", "1000"].includes(item.text)),
            tubeDiameterDdWaterPe: tubeDiameterAll.filter(
                item => ["110", "160", "180", "200", "250", "280", "315", "355", "400", "450", "500", "560", "630", "710", "800", "1000", "1200"].includes(item.text)),

            tubeDiameterWaterGreyIron: tubeDiameterAll.filter(
                item => ["80", "100", "125", "150", "200", "250", "300", "350", "400", "450", "500", "600", "700", "800", "1000", "1200"].includes(item.text)),
            tubeDiameterTcWaterGreyIron: tubeDiameterAll.filter(
                item => ["80", "100", "125", "150", "200", "250", "300", "350", "400", "450", "500", "600", "700", "800", "1000"].includes(item.text)),

            tubeDiameterWaterSteel: tubeDiameterAll.filter(
                item => ["400", "500", "600", "700", "800", "1000", "1200"].includes(item.text)),

            tubeDiameterIfl: tubeDiameterAll.filter(
                item => ["150", "225", "300", "375", "400", "450", "500", "600", "800", "1000", "1200", "1600"].includes(item.text)),

            tubeDiameterSlPe: tubeDiameterAll.filter(
                item => ["110", "160", "180", "200", "250", "280", "315", "355", "400", "450", "500", "560", "630", "710", "800", "1000"].includes(item.text)),

            tubeDiameterSlGreyIron: tubeDiameterAll.filter(
                item => ["80", "100", "125", "150", "200", "250", "300", "350", "400", "450", "500", "600", "700", "800", "1000"].includes(item.text)),

            tubeDiameterPul: tubeDiameterAll.filter(
                item => ["150", "200", "250", "300", "350", "400"].includes(item.text)),

        };

        this.addCodesForOptionCollection(this.availableSelections.techniquesToCompare);
        this.addCodesForOptionCollection(this.availableSelections.typeOfLandscape);
        this.addCodesForOptionCollection(this.availableSelections.coating);
        this.addCodesForOptionCollection(this.availableSelections.streetType);
        this.addCodesForOptionCollection(this.availableSelections.asphaltType);
        this.addCodesForOptionCollection(this.availableSelections.tubeType);
        this.addCodesForOptionCollection(this.availableSelections.tubeMaterialAll);
        this.addCodesForOptionCollection(this.availableSelections.tubeDiameterAll);
        this.addCodesForOptionCollection(this.availableSelections.slopeAngle);

    };

    addCodesForOptionCollection(optionCollection: OptionList) {
        for(let option of optionCollection) {
            if(typeof option.code !== "undefined")
                this.ids[option.code] = option.id;
        }
    }
    
    getServerValue(id: number, options: OptionList ): number | string {
        let option = options.find(option => option.id === id);
        if(typeof option !== 'undefined')
            return option.serverValue;
        else
            throw new Error(`Unable to find id ${id} in option list ${JSON.stringify(options)}`);
    }

    getServerNumValue(id: number, options: OptionList ): number {
        let option = options.find(option => option.id === id);
        if(typeof option === 'undefined')
            throw new Error(`Unable to find id ${id} in option list ${JSON.stringify(options)}`);
        else if(typeof option.serverValue === 'number') 
            return option.serverValue;
        else
            throw new Error(`Wrong type of serverValue: ${typeof option.serverValue}`);
    }

    getServerStrValue(id: number, options: OptionList ): string {
        if(id === -1)
            return "";
        let option = options.find(option => option.id === id);
        if(typeof option === 'undefined')
            throw new Error(`Unable to find id ${id} in option list ${JSON.stringify(options)}`);
        else if(typeof option.serverValue === 'string') 
            return option.serverValue;
        else
            throw new Error(`Wrong type of serverValue: ${typeof option.serverValue}`);
    }

    getIdFromServerStrValue(serverValue: string, options: OptionList ): number {
        if(serverValue === "")
            return -1;
        let option = options.find(option => option.serverValue === serverValue);
        if(typeof option === 'undefined')
            throw new Error(`Unable to find server value ${serverValue} in option list ${JSON.stringify(options)}`);
        else if(typeof option.id === 'number') 
            return option.id;
        else
            throw new Error(`Wrong type of id: ${typeof option.id}`);
    }

    getIdFromServerNumValue(serverValue: number, options: OptionList ): number {
        let option = options.find(option => option.serverValue === serverValue);
        if(typeof option === 'undefined')
            throw new Error(`Unable to find server value ${serverValue} in option list ${JSON.stringify(options)}`);
        else if(typeof option.id === 'number') 
            return option.id;
        else
            throw new Error(`Wrong type of id: ${typeof option.id}`);
    }

    getTextValue(id: number, options: OptionList ): string {
        if(id === -1)
            return "";
        let option = options.find(option => option.id === id);
        if(typeof option === 'undefined')
            throw new Error(`Unable to find id ${id} in option list ${JSON.stringify(options)}`);
        else if(typeof option.text === 'string') 
            return option.text;
        else
            throw new Error(`Wrong type of text: ${typeof option.text}`);
    }

    isTechnologyValid(options: OptionList, partOfCode: string, value: number) {
        return options
            .filter(option => typeof option.code !== 'undefined' && option.code.includes(partOfCode))
            .map(option => option.id).includes(value);

    }
    
    isInsertionFlexibleLiningUsed(techniquesToCompare: number): boolean {
        return this.isTechnologyValid(this.availableSelections.techniquesToCompare, "_IFL", techniquesToCompare);
    }

    isDirectedDrillingUsed(techniquesToCompare: number): boolean {
        return this.isTechnologyValid(this.availableSelections.techniquesToCompare, "_DD", techniquesToCompare);
    }
    
    isTubeCrackingUsed(techniquesToCompare: number): boolean {
        return this.isTechnologyValid(this.availableSelections.techniquesToCompare, "_TC", techniquesToCompare);
    }

    isSlipliningUsed(techniquesToCompare: number): boolean {
        return this.isTechnologyValid(this.availableSelections.techniquesToCompare, "_SL", techniquesToCompare);
    }

    isPuLiningUsed(techniquesToCompare: number): boolean {
        return this.isTechnologyValid(this.availableSelections.techniquesToCompare, "_PUL", techniquesToCompare);
    }


}


// WEBPACK FOOTER //
// ./src/common/OptionManager.js